module.exports = __webpack_public_path__ + "img/succes-logo.1b4295c0.png";